import ajax from '../utils/request'
const aiManageApi = {
  /********************************系统管理*********************************** */
  /********************************系统配置*********************************** */
  // 获取系统配置列表
  getSysConfigList(params) {
    return ajax({
      url: '/sys_config/list',
      type: 'get',
      params: params
    })
  },
  // 添加系统配置
  addSysConfig(params) {
    return ajax({
      url: '/sys_config/add',
      type: 'post',
      params: params
    })
  },
  // 删除系统配置
  delSysConfig(params) {
    return ajax({
      url: '/sys_config/del',
      type: 'delete',
      params: params
    })
  },
  // 修改系统配置
  updateSysConfig(params) {
    return ajax({
      url: '/sys_config/update',
      type: 'post',
      params: params
    })
  },
  checkSysConfig(params) {
    return ajax({
      url: '/sys_config/check',
      type: 'post',
      params: params
    })
  }
}
export default aiManageApi
